import React from "react";
import { motion } from "framer-motion";
import HeaderComponent from "./HeaderComponent";
import PreviousEventSection from "./PreviousEventSection";
import Newsletter from "./Newsletter";

const cities = [
  "ATC Africa Nigeria",
  "ATC Africa Zimbabwe",
  "ATC Africa Ghana",
  "ATC Africa Nairobi",
  "ATC Africa Kenya",
  "ATC Africa Kenya",
  "ATC Africa SA",
  "ATC Africa Italy",
  "ATC Africa Nairobi",
];

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, type: "spring", stiffness: 120 },
  }),
};

export default function Whoiscoming() {
  return (
    <>
      <HeaderComponent />

      <div className="w-screen flex flex-col items-center py-12 bg-gray-50">
        <motion.h2
          className="text-4xl sm:text-5xl md:text-5xl mb-6 font-bold tracking-wide text-center text-black px-4 sm:px-0"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          See Who{" "}
          <span className="bg-[#F63A0A] py-1 px-3 text-white rounded-md">
            is Coming
          </span>
        </motion.h2>

        <motion.p
          className="text-lg sm:text-xl md:text-2xl leading-7 w-full max-w-2xl mb-10 mx-auto text-center text-black px-4 sm:px-0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          Our Chapters that Participate.
        </motion.p>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-10 w-full max-w-6xl px-20 sm:px-0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          {cities.map((city, index) => (
            <motion.div
              key={index}
              custom={index}
              variants={cardVariants}
              initial="hidden"
              animate="show"
              whileHover={{
                scale: 1.05,
                boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
              }}
              className="border-2 border-[#F63A0A] rounded-xl px-4 py-4 sm:px-6 sm:py-6 text-center font-semibold text-black transition-all duration-300 max-w-full"
            >
              {city}
            </motion.div>
          ))}
        </motion.div>
      </div>

      <PreviousEventSection />

    </>
  );
}
